<button
        type="button"
        (click)="onClick()"
        [attr.title]="title"
        *appIfPermission="[permission]"
        [ngClass]="{
    'rounded py-3 flex flex-row items-center text-sm font-bold w-full':
      true,
    'bg-primaryWashed text-primaryDark': isExpanded,
    'text-grayDark hover:bg-grayNavi hover:text-primaryDark': !isExpanded
  }"
>
  <!-- icon -->
  <div
          class="relative text-lg flex flex-shrink-0 items-center justify-center w-10"
  >
    <i [class]="icon"></i>

    <div
            *ngIf="notificationCount > 0"
            class="absolute top-0 right-0 bg-orange text-white text-xs font-bold rounded-full h-5 px-2 flex items-center justify-center z-50 shadow-md"
            [style.transform]="isShrunk ? 'translate(50%, -90%)' : 'translate(410%, -90%)'"
            [title]="notificationTooltip"
    >
      <span class="tabular-nums">{{ notificationCount }}</span>
    </div>
  </div>

  <!-- label -->
  <span
          class="sidebar-toggle-label pl-1 pr-3 relative overflow-hidden"
          [ngClass]="{'sidebar-toggle-label--hidden': isShrunk}"
          style="top: 2px"
  >
    {{ label }}
  </span>

  <!-- chevron -->
  <span
          class="sidebar-toggle-chevron ml-auto pr-3"
          [ngClass]="{'sidebar-toggle-chevron--hidden': isShrunk}">
    <i
            class="fas"
            [ngClass]="isExpanded ? 'fa-chevron-left' : 'fa-chevron-right'"
    ></i>
  </span>
</button>
